// /**
//  * Using for recomendation products and recent view products
//  */
// if (!customElements.get('product-slider')) {
//   customElements.define(
//     'product-slider',
//     class ProductSlider extends HTMLElement {
//       constructor() {
//         super();
//       }

//       connectedCallback() {
//         this.selectors = {
//           productsWrap: '.products-grid-wrap',
//           products: '.products-grid',
//           nextEl: '.swiper-button-next',
//           prevEl: '.swiper-button-prev',
//           pagination: '.swiper-pagination',
//         };
//         this.classes = {
//           grid: 'f-grid',
//           swiper: 'swiper',
//           swiperWrapper: 'swiper-wrapper',
//         };

//         this.sectionId = this.dataset.sectionId;
//         this.elements = FoxTheme.utils.queryDomNodes(this.selectors, this);
//         this.elements.section = this.closest(`.section-${this.sectionId}`);

//         this.enableSlider = this.dataset.enableSlider === 'true';
//         this.items = parseInt(this.dataset.items);
//         this.tabletItems = parseInt(this.dataset.tabletItems);
//         this.totalItems = parseInt(this.dataset.totalItems);
//         this.paginationType = this.dataset.paginationType || 'bullets';

//         this.sliderInstance = false;

//         if (!this.enableSlider) return;

//         if (!this.elements.productsWrap || !this.elements.products) return;

//         const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
//         mql.onchange = this.init.bind(this);

//         const mqlTablet = window.matchMedia(FoxTheme.config.mediaQueryTablet);
//         mqlTablet.onchange = this.init.bind(this);

//         this.init();
//       }

//       init() {
//         if (FoxTheme.config.mqlMobile) {
//           this.destroySlider();
//         } else {
//           const currentItems = FoxTheme.config.mqlTablet ? this.tabletItems : this.items;

//           if (this.totalItems > currentItems) {
//             this.initSlider();
//           } else {
//             this.destroySlider();
//           }
//         }
//       }

//       initSlider() {
//         if (typeof this.sliderInstance === 'object') return;

//         const columnGap = window.getComputedStyle(this.elements.products).getPropertyValue('--f-column-gap');
//         const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10;

//         this.sliderOptions = {
//           slidesPerView: 2,
//           spaceBetween: spaceBetween,
//           navigation: {
//             nextEl: this.elements.nextEl,
//             prevEl: this.elements.prevEl,
//           },
//           pagination: {
//             el: this.elements.pagination,
//             type: this.paginationType,
//           },
//           breakpoints: {
//             768: {
//               slidesPerView: this.tabletItems,
//             },
//             1024: {
//               slidesPerView: this.items,
//             },
//           },
//           loop: false,
//           threshold: 2,
//           mousewheel: {
//             enabled: true,
//             forceToAxis: true,
//           },
//         };

//         this.elements.productsWrap.classList.add(this.classes.swiper);
//         this.elements.products.classList.remove(this.classes.grid);
//         this.elements.products.classList.add(this.classes.swiperWrapper);

//         this.sliderInstance = new window.FoxTheme.Carousel(this.elements.productsWrap, this.sliderOptions, [
//           FoxTheme.Swiper.Mousewheel,
//         ]);
//         this.sliderInstance.init();
//         this.handleAccessibility();
//         this.fixQuickviewDuplicate();
//         this.calcNavButtonsPosition();
//       }

//       handleAccessibility() {
//         const focusableElements = FoxTheme.a11y.getFocusableElements(this);

//         focusableElements.forEach((element) => {
//           element.addEventListener('focusin', (event) => {
//             if (event.relatedTarget !== null) {
//               if (element.closest('.swiper-slide')) {
//                 const slide = element.closest('.swiper-slide');
//                 this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
//               }
//             } else {
//               element.blur();
//             }
//           });
//         });
//       }

//       destroySlider() {
//         this.elements.productsWrap.classList.remove(this.classes.swiper);
//         this.elements.products.classList.remove(this.classes.swiperWrapper);
//         this.elements.products.classList.add(this.classes.grid);
//         if (typeof this.sliderInstance !== 'object') return;
//         this.sliderInstance.slider.destroy();
//         this.sliderInstance = false;
//       }

//       fixQuickviewDuplicate() {
//         let modalIds = [];
//         Array.from(this.querySelectorAll('quick-view-modal')).forEach((modal) => {
//           const modalID = modal.getAttribute('id');
//           if (modalIds.includes(modalID)) {
//             modal.remove();
//           } else {
//             modalIds.push(modalID);
//           }
//         });
//       }

//       calcNavButtonsPosition() {
//         if (this.dataset.navigationPosition !== 'center_image') return;

//         const firstMedia = this.querySelector('.product-card__image-wrapper');
//         const controls = this.querySelector('.swiper-controls');
//         if (controls && firstMedia && firstMedia.clientHeight > 0) {
//           controls.style.setProperty('--swiper-navigation-top-offset', parseInt(firstMedia.clientHeight) / 2 + 'px');
//         }
//       }
//     }
//   );
// }


/**
 * Using for recomendation products and recent view products
 */
if (!customElements.get('product-slider')) {
  customElements.define(
    'product-slider',
    class ProductSlider extends HTMLElement {
      constructor() {
        super();
        this.onPrevClick = null;
        this.onNextClick = null;
      }

      connectedCallback() {
        this.selectors = {
          productsWrap: '.products-grid-wrap',
          products: '.products-grid',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          pagination: '.swiper-pagination',
          controls: '.swiper-controls',
        };
        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.sectionId = this.dataset.sectionId;
        this.elements = FoxTheme.utils.queryDomNodes(this.selectors, this);
        this.elements.section = this.closest(`.section-${this.sectionId}`);

        this.enableSlider = this.dataset.enableSlider === 'true';
        this.items = parseInt(this.dataset.items);
        this.tabletItems = parseInt(this.dataset.tabletItems);
        this.totalItems = parseInt(this.dataset.totalItems);
        this.paginationType = this.dataset.paginationType || 'bullets';

        this.sliderInstance = false;

        if (!this.enableSlider) return;

        if (!this.elements.productsWrap || !this.elements.products) return;

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.init.bind(this);

        const mqlTablet = window.matchMedia(FoxTheme.config.mediaQueryTablet);
        mqlTablet.onchange = this.init.bind(this);

        this.init();
      }

      init() {
        const currentItems = FoxTheme.config.mqlTablet ? this.tabletItems : this.items;
        if (FoxTheme.config.mqlMobile) {
          this.destroySlider();
          this.updateControlsState(false);
        } else {
          if (this.totalItems > currentItems) {
            this.initSlider();
            this.updateControlsState(true);
          } else {
            this.destroySlider();
            this.updateControlsState(false);
          }
        }
      }

      initSlider() {
        if (typeof this.sliderInstance === 'object') return;

        const columnGap = window.getComputedStyle(this.elements.products).getPropertyValue('--f-column-gap');
        const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10;

        this.sliderOptions = {
          slidesPerView: 2,
          spaceBetween: spaceBetween,
          navigation: {
            nextEl: this.elements.nextEl,
            prevEl: this.elements.prevEl,
          },
          pagination: {
            el: this.elements.pagination,
            type: this.paginationType,
          },
          breakpoints: {
            768: {
              slidesPerView: this.tabletItems,
            },
            1024: {
              slidesPerView: this.items,
            },
          },
          loop: false,
          threshold: 2,
          mousewheel: {
            enabled: true,
            forceToAxis: true,
          },
        };

        this.elements.productsWrap.classList.add(this.classes.swiper);
        this.elements.products.classList.remove(this.classes.grid);
        this.elements.products.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(this.elements.productsWrap, this.sliderOptions, [
          FoxTheme.Swiper.Mousewheel,
          FoxTheme.Swiper.Navigation,
          FoxTheme.Swiper.Pagination,
        ]);
        this.sliderInstance.init();
        this.bindNavigationState();
        this.handleAccessibility();
        this.fixQuickviewDuplicate();
        this.calcNavButtonsPosition();
      }

      handleAccessibility() {
        const focusableElements = FoxTheme.a11y.getFocusableElements(this);

        focusableElements.forEach((element) => {
          element.addEventListener('focusin', (event) => {
            if (event.relatedTarget !== null) {
              if (element.closest('.swiper-slide')) {
                const slide = element.closest('.swiper-slide');
                this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
              }
            } else {
              element.blur();
            }
          });
        });
      }

      destroySlider() {
        this.unbindNavigationClickFallback();
        this.elements.productsWrap.classList.remove(this.classes.swiper);
        this.elements.products.classList.remove(this.classes.swiperWrapper);
        this.elements.products.classList.add(this.classes.grid);
        if (typeof this.sliderInstance !== 'object') return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }

      fixQuickviewDuplicate() {
        let modalIds = [];
        Array.from(this.querySelectorAll('quick-view-modal')).forEach((modal) => {
          const modalID = modal.getAttribute('id');
          if (modalIds.includes(modalID)) {
            modal.remove();
          } else {
            modalIds.push(modalID);
          }
        });
      }

      calcNavButtonsPosition() {
        if (this.dataset.navigationPosition !== 'center_image') return;

        const firstMedia = this.querySelector('.product-card__image-wrapper');
        const controls = this.querySelector('.swiper-controls');
        if (controls && firstMedia && firstMedia.clientHeight > 0) {
          controls.style.setProperty('--swiper-navigation-top-offset', parseInt(firstMedia.clientHeight) / 2 + 'px');
        }
      }

      bindNavigationState() {
        if (typeof this.sliderInstance !== 'object' || !this.sliderInstance.slider) return;
        const swiper = this.sliderInstance.slider;
        this.rebindSwiperControls(swiper);
        setTimeout(() => this.rebindSwiperControls(swiper), 0);
        setTimeout(() => this.rebindSwiperControls(swiper), 200);
        this.bindNavigationClickFallback(swiper);
        this.updateNavButtonsDisabled(swiper);
        swiper.on('init', () => this.rebindSwiperControls(swiper));
        swiper.on('slideChange', () => this.updateNavButtonsDisabled(swiper));
        swiper.on('resize', () => {
          this.rebindSwiperControls(swiper);
          this.updateNavButtonsDisabled(swiper);
        });
      }

      rebindSwiperControls(swiper) {
        if (!swiper) return;

        const controls = this.querySelector('.swiper-controls');
        const nextEl = controls ? controls.querySelector('.swiper-button-next') : this.elements.nextEl;
        const prevEl = controls ? controls.querySelector('.swiper-button-prev') : this.elements.prevEl;
        const paginationEl = controls ? controls.querySelector('.swiper-pagination') : this.elements.pagination;

        if (nextEl && prevEl) {
          swiper.params.navigation = swiper.params.navigation || {};
          swiper.params.navigation.nextEl = nextEl;
          swiper.params.navigation.prevEl = prevEl;
          swiper.navigation?.destroy?.();
          swiper.navigation?.init?.();
          swiper.navigation?.update?.();
        }

        if (paginationEl) {
          swiper.params.pagination = swiper.params.pagination || {};
          swiper.params.pagination.el = paginationEl;
          swiper.pagination?.destroy?.();
          swiper.pagination?.init?.();
          swiper.pagination?.render?.();
          swiper.pagination?.update?.();
        }

        this.elements.nextEl = nextEl || this.elements.nextEl;
        this.elements.prevEl = prevEl || this.elements.prevEl;
        this.elements.pagination = paginationEl || this.elements.pagination;
      }

      bindNavigationClickFallback(swiper) {
        if (this.elements.prevEl) {
          if (this.onPrevClick) {
            this.elements.prevEl.removeEventListener('click', this.onPrevClick);
          }
          this.onPrevClick = (event) => {
            event.preventDefault();
            event.stopPropagation();
            swiper.slidePrev();
          };
          this.elements.prevEl.addEventListener('click', this.onPrevClick);
        }

        if (this.elements.nextEl) {
          if (this.onNextClick) {
            this.elements.nextEl.removeEventListener('click', this.onNextClick);
          }
          this.onNextClick = (event) => {
            event.preventDefault();
            event.stopPropagation();
            swiper.slideNext();
          };
          this.elements.nextEl.addEventListener('click', this.onNextClick);
        }
      }

      unbindNavigationClickFallback() {
        if (this.elements.prevEl && this.onPrevClick) {
          this.elements.prevEl.removeEventListener('click', this.onPrevClick);
        }
        if (this.elements.nextEl && this.onNextClick) {
          this.elements.nextEl.removeEventListener('click', this.onNextClick);
        }
      }

      updateControlsState(isActive) {
        const controls = this.elements.controls;
        if (!controls) return;

        controls.classList.toggle('hidden', !isActive);
        controls.setAttribute('aria-hidden', String(!isActive));

        if (!isActive) {
          if (this.elements.prevEl) {
            this.elements.prevEl.setAttribute('aria-disabled', 'true');
            this.elements.prevEl.classList.add('swiper-button-disabled');
          }
          if (this.elements.nextEl) {
            this.elements.nextEl.setAttribute('aria-disabled', 'true');
            this.elements.nextEl.classList.add('swiper-button-disabled');
          }
        }
      }

      updateNavButtonsDisabled(swiper) {
        if (!swiper) return;
        if (this.elements.prevEl) {
          this.elements.prevEl.setAttribute('aria-disabled', String(swiper.isBeginning));
          this.elements.prevEl.classList.toggle('swiper-button-disabled', swiper.isBeginning);
        }
        if (this.elements.nextEl) {
          this.elements.nextEl.setAttribute('aria-disabled', String(swiper.isEnd));
          this.elements.nextEl.classList.toggle('swiper-button-disabled', swiper.isEnd);
        }
      }
    }
  );
}
